import React, { CSSProperties } from "react";
import Select from "react-select";
import SearchIcon from "../../assets/theme/images/search-box-icon.png";
type props = {
  onChange?: Function;
  options?: Array<{}>;
  extraProps?: any;
  onInputChange?: (input: string) => void;
  className?: string;
  isMulti?: boolean;
  value?: any;
  placeholder?: string;
};

export default function SearchSelect(props: props) {
  return (
    <div className={`${props.className}  lg:w-full relative`}>
      <img
        src={SearchIcon}
        alt={""}
        className="absolute top-[30%] left-[2%] z-10 w-4"
      />
      <Select
        {...props.extraProps}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            background: "#FFFFFF",
            border: "none",
            boxShadow: "none",
            paddingLeft: "1rem",
            borderRadius: "16px",
            minHeight: "3rem",
            fontSize: "16px",
          }),
          input: (baseStyles, state) => ({
            ...baseStyles,
            color: "black",
            outline: "none",
          }),
          container: (baseStyles, state) => ({
            ...baseStyles,
          }),
          indicatorsContainer: (baseStyles, state) => ({
            ...baseStyles,
            display: "none",
          }),
          indicatorSeparator: (baseStyles, state) => ({
            ...baseStyles,
            display: "none",
          }),
          valueContainer: (baseStyles, state) => ({
            ...baseStyles,
            color: "green",
            outline: "none",
          }),
          dropdownIndicator: (baseStyles, state) => ({
            ...baseStyles,
          }),
          placeholder: (baseStyles, state) => ({
            ...baseStyles,
            color: "#777777",
            // fontSize: ".875rem",
            fontWeight: "500",
            // lineHeight: "1.05rem",
          }),
          singleValue: (baseStyles, state) => ({
            ...baseStyles,
            color: "black",
          }),

          menu: (baseStyles, state) => ({
            ...baseStyles,
            color: "black",
          }),
          option: (baseStyles, state) => ({
            ...baseStyles,
            ":hover": {
              background: "#E1D0D8",
            },
            background: state.isSelected ? "rgba(255, 138, 0, 1)" : "white",
          }),
          menuList: (baseStyles) => ({
            ...baseStyles,
            maxHeight: "160px",
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "rgba(255, 138, 0, 1)",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
          }),
        }}
        placeholder={props.placeholder}
        options={props.options}
        onChange={props.onChange}
        onInputChange={props.onInputChange}
        isMulti={props.isMulti}
        value={props.value}
      />
    </div>
  );
}
